const data = {
  body: '<g fill="none"><path d="M11.9999 20L2.99991 4L20.9999 4L11.9999 20Z" fill="currentColor"/></g>',
  width: 24,
  height: 24
}
export default data
